export default "__VITE_ASSET__8667e544__"